module.exports = "<div *ngIf=\"this.empty\">Brak danych</div>\n<div #chart [ngClass]=\"chartClass\">\n  <!-- Chart will appear here -->\n</div>\n"